const BEFORE_REPAIR = 'รูปภาพก่อนการซ่อม';
const AFTER_REPAIR = 'รูปภาพหลังการซ่อม';

export const WORD_TYPE_IMAGE_REPAIR = {
    BEFORE_REPAIR,
    AFTER_REPAIR,
};
